export default {
  projectDesc: 'A simple, easier and highly customized menu solution',
  demo: {
    basic: 'Basic options',
    regular: 'Regular menu',
    advanced: 'Advanced menu',
    customWidth: 'Custom menu width',
    caller: 'Custom menu trigger',
    align: 'Menu align direction',
    rightClick: 'Mouse right click to call menu',
    move: 'Mouse move to call menu',
    noTitle: 'Close header bar',
    embed: 'Embedded menu to page',
    groupActive: 'Specifies the grouping index that is activated by default when the menu is first displayed',
    slot: 'Use slots to customize the menu item display',
    regularHeader: 'Menu items in title format',
    regularLevel: 'Regular menu multiple level',
    advancedShowField: 'Use function to format display content',
    advancedNoQuery: 'Close search bar',
    advancedNoScroll: 'Close scroll bar',
    advancedInit: 'Specified the menu item selected by default',
    advancedMultipleInit: 'Specified multiple menu items selected by default',
    regularGroup: 'Regular menu group type',
    advancedGroup: 'Advanced menu group type',
    format: 'Menu data format'
  },
  option: {
    value: 'selected items keyField value, multiple items use "," symbol to split. example: "2,4,7"',
    data: 'menu data source',
    keyField: 'specified the field as key field',
    showField: 'string type to specified content field. also can set function type to custom row content',
    type: 'the menu type',
    align: 'menu align direction',
    embed: 'set menu embedded to page',
    rightClick: 'mouse right click to call menu',
    title: 'the default title text in header bar, set option to <code>false</code> to close header bar',
    query: 'whether show advanced menu search bar',
    maxSelected: 'the max selected limited in multiple select mode',
    multiple: 'multiple select mode, the selected item will be shown as tag',
    scroll: 'limit list height and show scroll bar',
    disabled: 'disabled plugin',
    width: 'custom menu container width',
    fullWidth: 'menu trigger use "block" to display',
    activeGroup: 'Specifies the grouping index that is activated by default when the menu is first displayed'
  },
  event: {
    values: 'return selected rows data',
    show: 'trigger by menu open/show',
    hide: 'trigger by menu close'
  },
  api: {
    desc: 'Before calling the plugin API, need to specified <code>ref</code> attribute and call API like : <code>this.$refs.xxx</code>',
    clear: 'clear all selected items'
  }
}
